import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader } from "lucide-react";

export const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, userRole, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-h-screen">
        <div className="spinner-border text-primary" role="status">
          <Loader className="animate-spin text-indigo-500 mb-4" size={36} />
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/Signin-Signup" replace />;
  }

  // If role is required and user doesn't have it, redirect to appropriate dashboard
  if (requiredRole && userRole !== requiredRole) {
    // Redirect based on actual role
    switch (userRole) {
      case "admin":
        return <Navigate to="/admindashboard" replace />;
      case "expert":
        return <Navigate to="/expert-dashboard" replace />;
      default:
        return <Navigate to="/dashboard" replace />;
    }
  }

  // If authenticated and has the required role (or no role required), render the children
  return children;
};
